import {SearchError} from './SearchError.js'

export class GetSearchDataFromUrlError extends SearchError {
  static create(message) {
    return GetSearchDataFromUrlError(message)
  }
}
